import { createMuiTheme, responsiveFontSizes } from '@material-ui/core'

// A custom theme for this app
let theme_dark = createMuiTheme({
  palette: {
    primary: {
      main: '#0098dc',
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#78D64B', // green,
      alt1: '#34A798', // teal
      alt2: '#DE7C00', // orange
      alt3: '#893B67', // purple
      alt4: '#FFC845', // yellow
      alt5: '#8F6A2A' // brown
    },
    tertiary: {
      main: '#164E71'
    }, 
    grey: {
      main: '#E6E7E9'
    },
    background: {
      default: '#222'
    },
    background_footer: {
        main: '#000',
    },
    text: {
      primary: '#797777',
      contrastText: '#fff'
    },
    error: {
      main: '#ff3d00'
    }
  },
  typography: {
    fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
    h1: {
      fontSize: '1.5rem',
      fontWeight: '500',
      color:'#7DA1CA',
      lineHeight: '2rem',
      marginBottom:10
    },
    h2: {
      fontSize: '1.2rem',
      fontWeight: '300',
      lineHeight:'1.5rem',
      marginBottom:10
    },
    h3: {
      // fontFamily: 'Roboto',
      fontSize: '1rem',
      fontWeight: '300',
    },
    h4: {
      fontSize: '1rem',
      fontWeight: '300'
    },
    h5: {
      fontSize: '1rem',
      fontWeight: '300'
    },
    h6: {
      fontSize: '1rem',
      fontWeight: '500',
      textTransform: 'inherit'
    },
    body:{
        fontSize: '1rem',
        fontWeight: '300'
    },
    body2: {
      fontSize: '1.25rem',
      fontWeight: '300',
    },
    caption: {
      fontSize: '1.125rem',
      fontWeight: '400',
      lineHeight: '1.5',
      display: 'block'
    }
  },
  overrides: {
    MuiContainer: {
        root: {
            width: '100%!important',
        }
    },
    MuiTabs:{
        root:{
            backgroundColor: '#000'
        },
    },
    MuiPaper: {
        root: {
            backgroundColor: '#000',
        },
        outlined: {
            border: '1px solid #0098dc',
        }
    },
    MuiButton: {
      root: {
        padding:0,
        borderRadius: '12px',
        //backgroundColor: '#97D700',
          backgroundColor: '#0098dc',
        color: 'white',
        textAlign: 'center',
        textTransform: 'inherit',
        '&:hover': {
          backgroundColor: '#6a8cb9',
          color: 'white'
        }
      },
      text: {
        padding: '8px 36px',
        fontWeight: '600',
        fontSize: '12px'
      }
    },
  }
})

//theme = responsiveFontSizes(theme)

export default theme_dark
